<!--<div *ngIf="isLoading">Loading...</div>-->

<!--Chart:-->
<!--<mc-driver-results-chart-->
<!--  [results$]="raceRanking.race.results$"-->
<!--  *ngIf="!!(raceRanking.race.results$ | async)?.length"-->
<!--&gt;</mc-driver-results-chart>-->


<div *ngIf="!!raceRanking && !!(raceRanking.standings$ | async)?.length">
  <h4>
    {{raceRanking.ranking.name}}
    <small>{{raceRanking.ranking.description}}</small>
  </h4>

  <table class="table">
    <thead>
    <tr>
      <th scope="col" class="position">#</th>
      <th scope="col" class="start-number">Number</th>
      <th scope="col">Driver</th>
      <th scope="col" *ngIf="(raceRanking.rankingRaceStages | keyvalue).length > 1" class="race-stage">Stage</th>
      <th scope="col">Laptimes</th>
      <th scope="col" class="points">Points</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let standing of raceRanking.standings$ | async; trackBy: trackRaceStanding">
      <tr class="primary-row" (click)="toggleRowDetails(standing.driver.startNumber);">
        <td scope="row" class="position">{{standing.position}}.</td>
        <th class="start-number" title="RFIDs: {{standing.driver.epcs.join(', ')}}">
          {{standing.driver.startNumber}}
        </th>
        <td class="driver-name">
          <span *ngIf="standing.driver.features.group" class="grid-sector grid-sector-{{standing.driver.features.group}}">
            <span class="grid-group-badge"></span>
          </span>
          {{standing.driver.name}}
          <small>{{standing.driver.model}}</small>
        </td>
        <td class="race-stage" *ngIf="(raceRanking.rankingRaceStages | keyvalue).length > 1">
          <div *ngFor="let stageStandingsRecord of standing.stageStandings | keyvalue">
            {{ raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.name }}:
          </div>
        </td>
        <td class="laptimes">
          <div *ngFor="let stageStandingsRecord of standing.stageStandings | keyvalue"
            [class.complete]="stageStandingsRecord.value.bestResults?.length >= raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber"
          >
            {{ (raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber > 1 ? 'Ø' : '') + (stageStandingsRecord.value.bestResultsAverage | laptimeFilter:'minutes') }}
          </div>
        </td>
        <td class="points">
          {{ standing.points }}
          <i class="fa fa-trophy best-lap-icon" *ngIf="standing.hasRaceBastLap" title="Best lap in category"></i>
        </td>
      </tr>
      <tr *ngIf="rowDetailsOpen[standing.driver.startNumber]" class="details-row">
        <td colspan="2"></td>
        <td [attr.colspan]="(raceRanking.rankingRaceStages | keyvalue).length > 1 ? 2 : 1">
          <div *ngFor="let stageStandingsRecord of standing.stageStandings | keyvalue; let first = first;">
            <div class="stage-title">
              <div></div>
              <div>
                <span *ngIf="stageStandingsRecord.value.position > 0">
                  <b>P{{ stageStandingsRecord.value.position }}</b> in
                </span>
                <i
                  class="race-stage">{{ raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.name }}</i>
                (best {{ raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber > 1
                ? raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber
                : 'lap' }}):
              </div>
            </div>
            <div *ngFor="let result of stageStandingsRecord.value.results; trackBy: trackResult;"
              class="laptime-bar"
              [class.invalid]="!(result.microtime | laptimeRangeFilter:raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig)"
              [class.hidden]="!isAdmin && !(result.microtime | laptimeRangeFilter:raceRanking.rankingRaceStages[stageStandingsRecord.key].hardLimitResultsConfig)"
              [class.rejected]="result.verification === false"
              [class.restored]="result.verification === true"
            >
              <i
                class="verification-button fa fa-wrench"
                *ngIf="isModerable"
                (click)="toggleVerification(result);"
                (mouseover)="hoverResult(result)"
                (mouseout)="unhoverResult(result)"
              ></i>
              <span
                [style.width]="(result.microtime / (raceRanking.rankingRaceStages[stageStandingsRecord.key].hardLimitResultsConfig.maximumLapSeconds * 1000 * 1000) * 98) + '%'"
              ></span>
              <div *ngIf="isAdmin" title="Start time (start EPC) - finish time (finish EPC)"
                class="result-details"
                [class.different-tags-warning]="result.startEpc !== result.finishEpc"
              >
                {{ (result.createdAt - result.microtime / 1000) | date:'HH:mm:ss' }} ({{ result.startEpc }})
                -
                {{ result.createdAt | date:'HH:mm:ss' }} ({{ result.finishEpc }})
              </div>
            </div>
          </div>
        </td>
        <td colspan="2">
          <div *ngFor="let stageStandingsRecord of standing.stageStandings | keyvalue"
            class="laptimes"
          >
            <div class="stage-title">
              <div>
                <b
                  [class.complete]="stageStandingsRecord.value.bestResults?.length >= raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber">
                  {{ (raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig.bestLapsNumber > 1 ? 'Ø' : '') + (stageStandingsRecord.value.bestResultsAverage | laptimeFilter:'minutes') }}
                </b>
              </div>
              <div>
                {{ (stageStandingsRecord.value.points > 0 ? '+' : '') + stageStandingsRecord.value.points }}
              </div>
            </div>
            <div *ngFor="let result of stageStandingsRecord.value.results; trackBy: trackResult"
              class="result-wrapper"
              [class.out-of-range]="!(result.microtime | laptimeRangeFilter:raceRanking.rankingRaceStages[stageStandingsRecord.key].racePlanStage.resultsConfig)"
              [class.hidden]="!isAdmin && !(result.microtime | laptimeRangeFilter:raceRanking.rankingRaceStages[stageStandingsRecord.key].hardLimitResultsConfig)"
              [class.rejected]="result.verification === false"
              [class.restored]="result.verification === true"
              [class.in-best-laps]="stageStandingsRecord.value.bestResults.indexOf(result) > -1"
            >
              <mc-result
                [result]="result"
                (click)="$event.stopPropagation()"
              ></mc-result>
              <small> at {{ result.createdAt | date:'HH:mm:ss' }}</small>
              <div class="result-details" *ngIf="isAdmin" title="Result ID">
                {{ result._id }}
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>
